import { render } from "./FooterIcon.vue?vue&type=template&id=57375ae8&scoped=true"
import script from "./FooterIcon.vue?vue&type=script&lang=js"
export * from "./FooterIcon.vue?vue&type=script&lang=js"

import "./FooterIcon.vue?vue&type=style&index=0&id=57375ae8&scoped=true&lang=css"

import exportComponent from "/home/merlyn/Working/xiaorui.li/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57375ae8"]])

export default __exports__